export default __webpack_public_path__ + "static/media/energy.74266d57.webp";